import React from "react";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AuthSideSection } from "@/components/auth/AuthSideSection";

export default function AuthLayout() {
  const location = useLocation();
  const isNewStoreFlow = location.pathname.includes("/auth/new-store");
  return (
    <div className="bg-white dark:bg-background w-screen h-screen flex">
      <main className="flex flex-row w-full h-full overflow-hidden">
        {/* Left Column: Beautiful Side Section - Always visible */}
        <AuthSideSection />

        {/* Right Column: Dynamic Form Content with animations */}
        <div className="w-full md:w-1/2 bg-white dark:bg-card flex items-center justify-center p-6 md:p-10 relative md:border-l md:border-border/50">
          <div className={`w-full ${isNewStoreFlow ? "max-w-3xl" : "max-w-md"}`}>
            {/* Animated form container */}
            <div className="animate-fadeInUp">
              <Outlet />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
